import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import Category from "@/pages/public/Category";
import Article from "@/pages/public/Article";
import SearchPage from "@/pages/public/Search";
import About from "@/pages/public/About";
import StartHere from "@/pages/public/StartHere";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Posts from "@/pages/admin/Posts";
import PostEditor from "@/pages/admin/PostEditor";
import Media from "@/pages/admin/Media";
import Categories from "@/pages/admin/Categories";
import Tags from "@/pages/admin/Tags";
import Analytics from "@/pages/admin/Analytics";
import Settings from "@/pages/admin/Settings";
import Resources from "@/pages/admin/Resources";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-ink-950 flex items-center justify-center text-brand font-mono-label">loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/category/:slug" element={<Category />} />
                <Route path="/article/:slug" element={<Article />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/start-here" element={<StartHere />} />
              </Route>

              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="posts" element={<Posts />} />
                <Route path="posts/new" element={<PostEditor />} />
                <Route path="posts/:id" element={<PostEditor />} />
                <Route path="media" element={<Media />} />
                <Route path="categories" element={<Categories />} />
                <Route path="tags" element={<Tags />} />
                <Route path="resources" element={<Resources />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
